// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__box--K_WnF {
  border-radius: 4px;
  overflow: hidden;
  height: max-content;
  background-color: #fafafa;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__box--K_WnF .src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__boxTitle--nvgkH {
  padding: 16px 24px;
  font-weight: 700;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  column-gap: 12px;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__box--K_WnF .src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__fields--RLtLm {
  padding: 12px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__box--K_WnF .ant-form-item {
  margin-bottom: 0 !important;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__box--K_WnF .src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__viewButton--AaS1f {
  width: 100%;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__editor--gbYcv {
  background-color: #fffff0;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__editor--gbYcv > .src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__boxTitle--nvgkH {
  background-color: #f9e2a7;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__twoCols--OHp1s {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__threeCols--mkNXC {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 16px;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__threeCols--mkNXC .ant-form-item-control-input-content > div {
  width: 100%;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__divider--AR9fV {
  margin: 0 !important;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__divider--AR9fV .ant-divider-inner-text {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ManagementPage/Obj2Tab/forms/AttrForm2/MetaInfo/EditorInfo2/EditorInfo2.module.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AACF;AALA;EAOI,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAbA;EAeI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AAnBA;EAsBI,2BAAA;AAAJ;AAtBA;EA0BI,WAAA;AADJ;AAIA;EACE,yBAAA;AAFF;AAIA;EACE,yBAAA;AAFF;AAKA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAHF;AAKA;EACE,aAAA;EACA,kCAAA;EACA,gBAAA;AAHF;AAAA;EAMI,WAAA;AAHJ;AAOA;EACE,oBAAA;AALF;AAIA;EAGI,eAAA;AAJJ","sourcesContent":[".box {\n  border-radius: 4px;\n  overflow: hidden;\n  height: max-content;\n  background-color: #fafafa;\n\n  .boxTitle {\n    padding: 16px 24px;\n    font-weight: 700;\n    background-color: #f0f0f0;\n    display: flex;\n    align-items: center;\n    column-gap: 12px;\n  }\n  .fields {\n    padding: 12px 24px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n  // Убрать пустое место под элементом формы. Вместо него gap\n  :global(.ant-form-item) {\n    margin-bottom: 0 !important;\n  }\n\n  .viewButton {\n    width: 100%;\n  }\n}\n.editor {\n  background-color: #fffff0;\n}\n.editor > .boxTitle {\n  background-color: #f9e2a7;\n}\n\n.twoCols {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 16px;\n}\n.threeCols {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  column-gap: 16px;\n\n  :global(.ant-form-item-control-input-content) > div {\n    width: 100%;\n  }\n}\n\n.divider {\n  margin: 0 !important;\n  :global(.ant-divider-inner-text) {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__box--K_WnF`,
	"boxTitle": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__boxTitle--nvgkH`,
	"fields": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__fields--RLtLm`,
	"viewButton": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__viewButton--AaS1f`,
	"editor": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__editor--gbYcv`,
	"twoCols": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__twoCols--OHp1s`,
	"threeCols": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__threeCols--mkNXC`,
	"divider": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-EditorInfo2-EditorInfo2-module__divider--AR9fV`
};
export default ___CSS_LOADER_EXPORT___;
